import { render, staticRenderFns } from "./ComponentStats.vue?vue&type=template&id=85efc114&scoped=true&"
import script from "./ComponentStats.vue?vue&type=script&lang=js&"
export * from "./ComponentStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85efc114",
  null
  
)

export default component.exports